import { Link } from "react-router-dom";
import { Shield, Zap, Lock, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-[#1E293B] bg-[#0a0a0c]">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <div className="font-heading font-bold text-xl">genuine<span className="text-[#00FF66]">.</span>software</div>
          <p className="text-[#A1A1AA] text-sm mt-3 leading-relaxed">
            Original digital software licenses delivered instantly. No grey market. No keys revoked.
          </p>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-[#00FF66] mb-3">Catalog</h4>
          <ul className="space-y-2 text-sm text-[#A1A1AA]">
            <li><Link className="hover:text-[#00FF66]" to="/products?category=Windows">Windows</Link></li>
            <li><Link className="hover:text-[#00FF66]" to="/products?category=Office">Office</Link></li>
            <li><Link className="hover:text-[#00FF66]" to="/products?category=Antivirus">Antivirus</Link></li>
            <li><Link className="hover:text-[#00FF66]" to="/products?category=Autodesk">Autodesk</Link></li>
            <li><Link className="hover:text-[#00FF66]" to="/products">All products</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-[#00FF66] mb-3">Company</h4>
          <ul className="space-y-2 text-sm text-[#A1A1AA]">
            <li><Link className="hover:text-[#00FF66]" to="/about">About</Link></li>
            <li><Link className="hover:text-[#00FF66]" to="/faq">FAQ</Link></li>
            <li><Link className="hover:text-[#00FF66]" to="/contact">Contact</Link></li>
            <li><Link className="hover:text-[#00FF66]" to="/order-lookup">Track Order</Link></li>
            <li><Link data-testid="footer-privacy" className="hover:text-[#00FF66]" to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link data-testid="footer-terms" className="hover:text-[#00FF66]" to="/terms-of-service">Terms of Service</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-[#00FF66] mb-3">Why us</h4>
          <ul className="space-y-2 text-sm text-[#A1A1AA]">
            <li className="flex items-center gap-2"><Zap className="w-3.5 h-3.5 text-[#00FF66]" />Instant delivery</li>
            <li className="flex items-center gap-2"><Shield className="w-3.5 h-3.5 text-[#00FF66]" />100% genuine keys</li>
            <li className="flex items-center gap-2"><Lock className="w-3.5 h-3.5 text-[#00FF66]" />Secure checkout</li>
            <li className="flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-[#00FF66]" />Email + on-site delivery</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#1E293B] py-5 px-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#71717A] font-mono">
        <div data-testid="footer-copyright">
          © {new Date().getFullYear()} genuine.software — all rights reserved
        </div>
        <div className="flex items-center gap-5">
          <Link className="hover:text-[#00FF66]" to="/privacy-policy">Privacy Policy</Link>
          <span className="text-[#3F3F46]">·</span>
          <Link className="hover:text-[#00FF66]" to="/terms-of-service">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
}
